import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CoinsuranceTable } from './coinsurance-table';
import { CopaymentsTable } from './copayments-table';
import { DeductiblesTable } from './deductibles-table';
import { Footer } from './footer';
import { Header } from './header';
import { LimitationsTable } from './limitations-table';
import { Maximums } from './maximums';
import { Profile } from './profile';

export const PrintableReport = () => {
  return (
    <table>
      <thead css={{ display: 'table-header-group' }}>
        <Header style={css({ margin: theme.spacing(1, 2) })} showPrintButton={false} showSaveToPmsButton={false} />
      </thead>
      <tbody>
        <div css={{ margin: theme.spacing(2) }}>
          <Profile />
          <CopaymentsTable isPrintingReport />
          <CoinsuranceTable isPrintingReport />
          <DeductiblesTable isPrintingReport />
          <Maximums isPrintingReport />
          <LimitationsTable isPrintingReport />
        </div>
      </tbody>
      <tfoot css={{ display: 'table-footer-group' }}>
        <Footer />
      </tfoot>
    </table>
  );
};
